function standardEventProperties({ isAgent, householdResource }) {
  const searchParams = new URLSearchParams(window.location.search);
  const properties = {};

  // Append household attributes if the user is from the household (a client)
  // or they are an agent looking at a page that has the household in context
  const shouldAppendHouseholdParams = !isAgent || searchParams.has('householdId');

  if (shouldAppendHouseholdParams && householdResource) {
    const primaryClient = householdResource.attr('clients')
      .resources()
      .list()
      .find(client => client.attr('isPrimary') === 'true');

    if (primaryClient) {
      properties['primaryClient.signDate'] = primaryClient.attr('signDate');
    }

    properties['household.escalationType'] = householdResource.attr('escalationType');
    properties['household.escalationTime'] = householdResource.attr('escalationTime');
    properties['household.householdId'] = householdResource.attr('householdId');
    properties['household.primaryClientId'] = householdResource.attr('primaryClientId');
    properties['household.leadPlannerId'] = householdResource.attr('leadPlannerId');
    properties['household.csManagerId'] = householdResource.attr('csManagerId');
    properties['household.statusId'] = householdResource.attr('statusId');
    properties['household.sourceId'] = householdResource.attr('sourceId');
    properties['household.sourceTypeId'] = householdResource.attr('sourceTypeId');
    properties['household.sourcePartnerId'] = householdResource.attr('sourcePartnerId');
    properties['household.maritalStatus'] = householdResource.attr('maritalStatus');
    properties['household.serviceLevel'] = householdResource.attr('serviceLevel');
  }

  return properties;
}

export default standardEventProperties;
